import {
  funcScrollControl,
  funcLoad,
} from './index';

const funcEntry = (() => {


  funcScrollControl.noScroll();


  let sW = window.innerWidth;
  if (sW > 768) {
    const lenis = new Lenis();
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }


  if (document.querySelector("body#pageTop") !== null) {

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        funcLoad()
      }, 500);
    });

  } else {

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        funcLoad()
      }, 500);
    });

  }


})();
export default funcEntry;